import { Component, ReactNode } from 'react'
import { AlertTriangle, RefreshCw } from 'lucide-react'

interface Props {
  children: ReactNode
  /** Remonte la clé (ex: pathname) pour réinitialiser l'erreur au changement de page. */
  resetKey?: string
}
interface State {
  error: Error | null
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, info: unknown) {
    console.error('Dashboard render error:', error, info)
  }

  componentDidUpdate(prev: Props) {
    // Réinitialise quand on navigue vers une autre page.
    if (prev.resetKey !== this.props.resetKey && this.state.error) {
      this.setState({ error: null })
    }
  }

  render() {
    if (this.state.error) {
      return (
        <div className="max-w-2xl mx-auto py-12">
          <div className="rounded-2xl border border-red-200 dark:border-red-500/30 bg-red-50 dark:bg-red-500/10 p-8 text-center">
            <div className="w-12 h-12 rounded-xl bg-red-100 dark:bg-red-500/20 flex items-center justify-center mx-auto mb-4">
              <AlertTriangle className="h-6 w-6 text-red-600 dark:text-red-400" />
            </div>
            <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
              Cette page a rencontré une erreur
            </h2>
            <p className="text-sm text-gray-600 dark:text-neutral-400 mb-4">
              Le reste de votre espace reste accessible via le menu. Détail technique :
            </p>
            <pre className="text-left text-xs bg-white dark:bg-neutral-950 border border-red-200 dark:border-red-500/20 rounded-lg p-3 overflow-auto text-red-700 dark:text-red-300 mb-6">
              {this.state.error.message}
            </pre>
            <button
              onClick={() => this.setState({ error: null })}
              className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-black text-white dark:bg-white dark:text-black text-sm font-medium hover:opacity-90"
            >
              <RefreshCw className="h-4 w-4" />
              Réessayer
            </button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
